import {
    default as actions,
    UPDATER_CHECKER,
    UPDATER_FIRMWAREN,
    SET_UPDATER_FIRMWARE_DATA,
    EXEC_DOWNLOAD_UPDATE,
    REMIND_UPDATE,
    IGNORE_UPDATE_VERSION
} from './action';
import Storage from '../../services/api/store';
import Config from '../../config';
import CONSTANT from '../../constant';

const isRemind = Storage.get(CONSTANT.REMIND_UPDATE) !== null
    ? Storage.get(CONSTANT.REMIND_UPDATE)
    : true;

const defaultState = {
    code: null,
    model: {
        last: '',
        source: '',
        board: '',
        codey: {},
        date_time: '',
        is_support: true
    },
    progress: null,
    isAuto: false,
    isChecking: false,
    isNotNetwork: false,
    appVersion: Config.appVersion,
    ignoreVersions: Storage.get(CONSTANT.IGNORE_UPDATE_VERSIONS) || [],
    isRemind
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATER_FIRMWAREN:
            return Object.assign({}, state, {
                model: { codey: action.payload }
            });
        case IGNORE_UPDATE_VERSION:
            return Object.assign({}, state, {
                ignoreVersions: action.payload
            });
        case EXEC_DOWNLOAD_UPDATE:
            return Object.assign({}, state, { progress: action.payload });
        case UPDATER_CHECKER:
            return Object.assign({}, state, action.payload);
        case SET_UPDATER_FIRMWARE_DATA:
            return Object.assign({}, state, {
                firmware: action.payload
            });
        case REMIND_UPDATE:
            return Object.assign({}, state, {
                isRemind: action.payload
            });
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};